const ConfirmTRFBooking = async () => {
  window.location = "https://bdr.nexustours.com/bdr-login";
};

export default (ConfirmTRFBooking);